import { Box, Grid } from "@mui/material";
import { AssessmentInstanceDto, AssessmentQuestionDto, QuestionType } from "generated/CoreApi_v1";
import React from "react";
import { AssMediaView } from "views/assessment/components/AssMediaView";
import { AssPlayerEssay } from "views/assessment/player/Question/AssPlayerEssay";
import { AssPlayerFillIn } from "views/assessment/player/Question/AssPlayerFillIn";
import { AssPlayerFillInNumber } from "views/assessment/player/Question/AssPlayerFillInNumber";
import { AssPlayerMultipleChoice } from "views/assessment/player/Question/AssPlayerMultipleChoice";
import { AssPlayerStar } from "views/assessment/player/Question/AssPlayerStar";

interface IProps {
    essayText?: string;
    rating: number;
    selectedItems: string[];
    viewData: AssessmentInstanceDto;
    question: AssessmentQuestionDto;
    deployId?: string;
    onChangeEssay: (essay: string) => void;
    onChangeQuestion: (question: AssessmentQuestionDto) => void;
    onChangeMultiChoice: (selectedItems: string[]) => void;
    onChangeStar: (rating: number) => void;
}

export const AssPlayerAnswer: React.FC<IProps> = (props) => {

    const { essayText, rating, selectedItems, viewData, question, deployId, onChangeEssay, onChangeQuestion, onChangeMultiChoice, onChangeStar } = props;

    ///
    const RenderQuestionType = () => {
        switch (question?.questionType) {
            case QuestionType.SimpleChoice:
            case QuestionType.MultipleChoice:
                return <AssPlayerMultipleChoice
                    selectedItems={selectedItems}
                    viewData={viewData}
                    question={question}
                    deployId={deployId}
                    onChange={(selectedItems) => onChangeMultiChoice(selectedItems)}
                />;
            case QuestionType.Dropdown:
            case QuestionType.FillInText:
                return <AssPlayerFillIn
                    viewData={viewData}
                    question={question}
                    onChange={(question) => onChangeQuestion(question)}
                />;
            case QuestionType.FillInNumber:
                return <AssPlayerFillInNumber
                    viewData={viewData}
                    question={question}
                    onChange={(question) => onChangeQuestion(question)}
                />;
            case QuestionType.Essay:
                return <AssPlayerEssay
                    value={essayText}
                    viewData={viewData}
                    question={question}
                    onChange={(value) => onChangeEssay(value)}
                />;
            case QuestionType.Star:
                return <AssPlayerStar
                    viewData={viewData}
                    question={question}
                    deployId={deployId}
                    rating={rating}
                    onChange={(rating) => onChangeStar(rating)}
                />;
            default:
                return (<Box>Question doesn`t exist.</Box>);
        }
    };

    return (
        <>
            {
                question.attach?.imageWide &&
                <Grid container mt={1} wrap="nowrap">
                    <Grid size="grow"></Grid>
                    <Grid>
                        <AssMediaView attach={question.attach} />
                    </Grid>
                    <Grid size="grow"></Grid>
                </Grid>
            }
            <Grid container marginTop={2} columnSpacing={2} wrap="nowrap">
                {
                    question.attach != null && !question.attach?.imageWide &&
                    <Grid>
                        <AssMediaView attach={question.attach} />
                    </Grid>
                }
                <Grid size="grow">
                    {RenderQuestionType()}
                </Grid>
            </Grid>
        </>
    );
};
